import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=ea36613e"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports